import Component from "@tunnel-components/@sharded/header/component";
import * as Utils from "@Cyclope-Utils/index";
import { connect } from "react-redux";
import {
  LogoutActionCreator,
  ChangePassWordActionCreator,
} from "@tunnel-store/index";
import * as React from "react";
import * as Paths from "@tunnel-enums/index";
// import * as Lodash from 'lodash';

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onLogout
 * @name onOpen
 * @name onClose
 * @name redirectToNewUrl
 * @name render
 * @infos "https://cyclope.ai"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { boolean }      state.open
     * @property { boolean }      state.openAdmin
     */
    this.state = {
      open: false,
      openAdmin: false,
      openNotif: false,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onLogout = this.onLogout.bind(this);
    this.onOpen = this.onOpen.bind(this);
    this.onOpenAdmin = this.onOpenAdmin.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onCloseAdmin = this.onCloseAdmin.bind(this);
    this.onCloseTools = this.onCloseTools.bind(this);
    this.onNotification = this.onNotification.bind(this);
    this.onCloseNotification = this.onCloseNotification.bind(this);
  }
  /**
   * Fermerture / Ouverture d'une  fenêtre
   * @method
   * @name onOpen
   * @param {  }
   * @infos "https://cyclope.ai"
   */
  public onOpen = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ open: true }));
  };
  /**
   * Fermerture / Ouverture d'une  fenêtre
   * @method
   * @name onNotification
   * @param {  }
   * @infos "https://cyclope.ai"
   */
  public onNotification = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ openNotif: true }));
  };
  /**
   * Fermerture / Ouverture d'une  fenêtre
   * @method
   * @name onCloseNotification
   * @param {  }
   * @infos "https://cyclope.ai"
   */
  public onCloseNotification = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ openNotif: false }));
  };
  /**
   * Fermerture / Ouverture d'une  fenêtre
   * @method
   * @name onCloseTools
   * @param {  }
   * @infos "https://cyclope.ai"
   */
  public onCloseTools = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ open: false }));
  };

  /**
   * Fermerture / Ouverture d'une  fenêtre
   * @function onOpenAdmin
   * @param {  }
   * @infos "https://cyclope.ai"
   */
  public onOpenAdmin = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ openAdmin: true }));
  };
  /**
   * Fermerture / Ouverture d'une  fenêtre
   * @method
   * @name onCloseAdmin
   * @param {  }
   * @infos "https://cyclope.ai"
   */
  public onCloseAdmin = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ openAdmin: false }));
  };
  /**
   * Fermerture / Ouverture d'une  fenêtre
   * @function onClose
   * @param {  }
   * @infos "https://cyclope.ai"
   */
  public onClose = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ open: false }));
  };

  /**
   * Redirection vers un url spécifique
   * @function redirectToNewUrl
   * @param {  }
   * @infos "https://cyclope.ai"
   */
  public redirectToNewUrl() {
    /**
     * @constant
     * @description :
     * @name  options
     * @types any
     */
    const _URL: any = Paths.PathsNamesEnums.LOGIN;
    this.props.history.push(_URL);
  }
  /**
   * Se deconnecter du site
   * @function onLogout
   * @param {  }
   * @infos "https://cyclope.ai"
   */

  public onLogout() {
    // apparution d'un message flash
    this.props.onDeconnexion(true);

    // éxecution du callback
    setTimeout(() => {
      this.props.LogoutActionCreator().then(() => {
        window.location.reload(true);
        Utils.localStorageClear();
      });
    }, 8000);
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        onCloseNotification={this.onCloseNotification}
        onNotification={this.onNotification}
        onCloseTools={this.onCloseTools}
        onCloseAdmin={this.onCloseAdmin}
        {...this.state}
        {...this.props}
        onLogout={this.onLogout}
        onClose={this.onClose}
        onOpen={this.onOpen}
        onOpenAdmin={this.onOpenAdmin}
      />
    );
  }
}

export default connect(null, {
  LogoutActionCreator,
  ChangePassWordActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/header/container.tsx